/**
 * Program: SDL Common Component
 * Author: SDL
 * Description: SDL Common Component
 */
import SdlLoadingbar    from './loadingbar/LoadingBar';
import SdlModal         from './modal';
import SdlRegexInput    from './input/RegexInput';
import sdlPagination    from './pagination/Pagination';

const SdlControl = {
    // eslint-disable-next-line no-unused-vars
    install(Vue, options) {
        Vue.use(SdlModal, {
            dialog: true,
            dynamic: true,
            dynamicDefaults: { clickToClose: false },
            injectModalsContainer: true,
        });

        Vue.component('sdl-loadingbar', SdlLoadingbar);
        Vue.component('sdl-pagination', sdlPagination);
        Vue.component('sdl-regex-input', SdlRegexInput);
        // Exclude Editor from SDL common component related to license
        // Vue.component('sdl-editor', SdlEditor);
    },
};

export default SdlControl;



// WEBPACK FOOTER //
// ./src/components/common/control/index.js